import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskRequestsService } from './task-requests.service';
import { ITaskRequest } from './task-requests.interface';
import { TaskRequestsDetailComponent } from './task-requests-detail/task-requests-detail.component';
import { TaskRequestStatuses, TaskRequestStatusesColor } from './task-requests.constants';
import { Sort } from '@angular/material/sort';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { NotificationsService } from '../../../shared/notifications/notifications.service';
import { AuthService } from '../../../shared/services/auth.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { TaskModalComponent } from '../../tasks-page/tasks/task-modal/task-modal.component';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
let self: any;

@Component({
  selector: 'app-task-requests',
  templateUrl: './task-requests.component.html',
  styleUrls: ['./task-requests.component.css']
})
export class TaskRequestsComponent implements OnInit {
  taskRequests: ITaskRequest[] = [];
  loading: boolean = true;
  thereAreMore: boolean = false;
  filter: any;
  filtered = false;
  totalMoreMinTutorial = false;
  scrollSubscription!: Subscription;
  querySubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  taskRequestStatuses: any = TaskRequestStatuses;
  taskRequestStatusesKeys = Object.keys(TaskRequestStatuses);
  taskRequestStatusesColor: any = TaskRequestStatusesColor;
  taskRequestStatusesLabel: any = TaskRequestStatuses;

  constructor(
    private _TaskRequestsService: TaskRequestsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _NotificationsService: NotificationsService,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilService: UtilsService,
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
    this.filter = {
      filters: {
        status: '',
      },
      sort: '-createdAt',
      skip: 0,
      limit: 20,
      company: this._AuthService.companyId(),
    }
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => /*this.openNewClientModal()*/ console.log("boca"));
    })
  }

  ngOnInit() {
    this.filter = {
      filters: {
        status: '',
      },
      sort: '-createdAt',
      skip: 0,
      limit: 20,
      company: this._AuthService.companyId(),
    };

    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this._NotificationsService.countPendingTaskRequests();
    this.getTaskRequests(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    this.filtered = true;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getTaskRequests(true);
      }
    }, 1000);
  }

  getTaskRequests(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.taskRequests = [];
      this.clearSelection();
    }
    this._NotificationsService.countPendingTaskRequests();
    this._TaskRequestsService.getTaskRequests(this.filter).subscribe((taskRequests: any) => {
      console.log(taskRequests)
      this.taskRequests = _.concat(this.taskRequests, taskRequests);
      this.thereAreMore = taskRequests.length >= this.filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      this.filter.skip += this.filter.limit;
      this.getTaskRequests();
    }
  }

  sortTasks(sort: Sort | string) {
    this.filter.sort = (typeof sort == 'string') ? sort :
      ((sort.direction == 'asc') ? sort.active : ((sort.direction == 'desc') ? '-' + sort.active : ''));
    this.getTaskRequests(true);
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getTaskRequests(true);
  }

  openTasksRequestDetailModal(taskRequest: ITaskRequest) {
    let config = new MatDialogConfig();
    config.width = '500px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskRequestsDetailComponent, config);
    self.dialogRef.componentInstance.taskRequest = taskRequest;
    self.dialogRef.componentInstance.readOnly = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTaskRequests(true);
    });
  }

  openTaskRequestClient(taskRequest: any) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.taskRequest = taskRequest;
    self.dialogRef.componentInstance.task = { status: 'SCHEDULED' };
    self.dialogRef.componentInstance.scheduling = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      this.getTaskRequests(true)
    });
  }

  openRejectedTaskRequestConfirm(taskRequest: any) {
    const clientName = taskRequest?.client?.firstname;
    const clientLastname = taskRequest?.client?.lastname ? ` ${taskRequest?.client?.lastname}` : '';
    const modalOptions: IConfirmationDialogOptions = {
      title: "Rechazar Solicitud",
      message: `¿Está seguro de que desea rechazar la solicitud de ${clientName}${clientLastname}?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this.loading = true;
          this._TaskRequestsService.updateTaskRequest({
            _id: _.get(taskRequest, 'taskRequest._id', taskRequest._id),
            company: this._AuthService.companyId(),
            status: 'REJECTED'
          }).subscribe(ok => {
            this.getTaskRequests(true)
          })
        }
      });
  }

  openDeleteTaskRequestConfirm(taskRequest: ITaskRequest, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Agente",
      message: `Esta seguro que desea eliminar esta solicitud?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskRequestsService.deleteTaskRequest(taskRequest, hardDelete).subscribe(() => {
            if (!hardDelete) taskRequest.isDeleted = true;
            this.getTaskRequests(true);
          })
        }
      });
  }

  openRestoreTaskRequestConfirm(taskRequest: ITaskRequest) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Agente",
      message: "Esta seguro que desea restaurar esta solicitud?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskRequestsService.restoreTaskRequest(taskRequest).subscribe(() => {
            taskRequest.isDeleted = false;
            this.getTaskRequests(true);
          })
        }
      });
  }

  openAgent() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'agents'])
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.taskRequests.every(taskRequest => {
        const id = taskRequest?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.taskRequests.forEach(taskRequest => {
        const id = taskRequest?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}